import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

interface IColorCheckboxProps {
    id: string
    /** Valor do filtro (`yellow`, `blue`...), também o nome acessível da opção. */
    value: string
    /** Amostra exibida. */
    bgColor: string
    checked: boolean
    onChange: () => void
}

/** Amostra de cor do filtro da listagem, com o check por cima quando marcada. */
const ColorCheckbox: React.FC<IColorCheckboxProps> = ({ id, value, bgColor, checked, onChange }) => (
    <div className="min-w-[21px] min-h-[21px] relative">
        <input
            className="sr-only peer "
            type="checkbox"
            name="color[]"
            id={id}
            aria-label={`cor ${value}`}
            onChange={onChange}
            checked={checked}
        />
        <label
            className={`select-color-sidebar cursor-pointer focus:outline-hidden `}
            style={{ backgroundColor: bgColor }}
            htmlFor={id}
        >
            &nbsp;
        </label>
        {checked && (
            <label
                className="absolute hidden w-full h-full rounded-full peer-checked:flex justify-center items-center top-0 left-0 cursor-pointer"
                htmlFor={id}
            >
                <FontAwesomeIcon icon={faCheck} className={bgColor !== '#ffffff' ? 'text-white' : 'text-secondary'} />
            </label>
        )}
    </div>
)

export default ColorCheckbox
